import { createSlice } from "@reduxjs/toolkit"

interface AppState {
  usersData: Array<any>
  newUserGroups: Array<any>
  newUserPractices: Array<any>
  gaData: Array<any>
  advisorsData: Array<any>
  csmData: Array<any>
  userGroupsDetails: any
  officeManagersData: Array<any>
  groupAdminsData: Array<any>
  providersData: Array<any>
}

const initialState: AppState = {
  usersData: [],
  newUserGroups: [],
  newUserPractices: [],
  gaData: [],
  advisorsData: [],
  csmData: [],
  userGroupsDetails: [],
  officeManagersData: [],
  groupAdminsData: [],
  providersData: [],
}

const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    setUsersData: (state, action) => {
      state.usersData = action.payload
    },
    setNewUserGroups: (state, action) => {
      state.newUserGroups = action.payload
    },
    setNewUserPractices: (state, action) => {
      state.newUserPractices = action.payload
    },
    setGaData: (state, action) => {
      state.gaData = action.payload
    },
    setAdvisorsData: (state, action) => {
      state.advisorsData = action.payload
    },
    setCsmData: (state, action) => {
      state.csmData = action.payload
    },
    setOfficeManagersData: (state, action) => {
      state.officeManagersData = action.payload
    },
    setGroupAdminsData: (state, action) => {
      state.officeManagersData = action.payload
    },
    setProvidersData: (state, action) => {
      state.providersData = action.payload
    },
    setUserGroupsDetails: (state, action) => {
      const user = state.usersData.find((user) => user.uid == action.payload)

      state.userGroupsDetails = user?.associated_groups?.groups
    },
  },
})

export default usersSlice.reducer
export const {
  setUsersData,
  setNewUserGroups,
  setNewUserPractices,
  setGaData,
  setAdvisorsData,
  setCsmData,
  setUserGroupsDetails,
  setOfficeManagersData,
  setGroupAdminsData,
  setProvidersData,
} = usersSlice.actions
